import React from 'react';
import visualisation_svg from '../../../svg/IndividualTreatmentVisualisationBurst.svg'
import PropTypes from 'prop-types';

import IndividualTreatmentVisualisationBase from 'common/controls/IndividualTreatmentVisualisationBase'
import * as ControlConstants from 'common/controls/Magstim.Control.Constants'
import { CurrentLang } from 'common/utils/LocalisationUtils';

class IndividualTreatmentVisualisationBurst extends IndividualTreatmentVisualisationBase {
	
	constructor() {
		super();
		window._VisualisationBurst_setAdjustedPowerOutput = this.setAdjustedPowerOutput.bind(this);
		window._VisualisationBurst_setPowerOutput = this.setPowerOutput.bind(this);
		window._VisualisationBurst_setChargeDelay = this.setChargeDelay.bind(this);
		window._VisualisationBurst_setBurstsPerCycle = this.setBurstsPerCycle.bind(this);
		window._VisualisationBurst_setBurstsPerSecond = this.setBurstsPerSecond.bind(this);
		window._VisualisationBurst_setPulsesPerBurst = this.setPulsesPerBurst.bind(this);
		window._VisualisationBurst_setPulsesPerSecond = this.setPulsesPerSecond.bind(this);
		window._VisualisationBurst_setCycleTime = this.setCycleTime.bind(this);
		window._VisualisationBurst_setPowerChangePendingHighlight = this.setPowerChangePendingHighlight.bind(this);
	}

	onSvgLoad = (event) => {
		this.svgTreatment = event.target.contentDocument;
		this.setAdjustedPowerOutput(this.props.AdjustedPowerOutput);
		this.setPowerOutput(this.props.PowerOutput);
		this.setChargeDelay(this.props.ChargeDelay);
		this.setBurstsPerCycle(this.props.BurstsPerCycle);
		this.setBurstsPerSecond(this.props.BurstsPerSecond);
		this.setPulsesPerBurst(this.props.PulsesPerBurst);
		this.setPulsesPerSecond(this.props.PulsesPerSecond);
		this.setCycleTime(this.props.CycleTime);

		this.__set("labelCycleTime", CurrentLang().view_individual_treatment_burst_cycle_time);
	}
	
	render() {
		return (
			<object aria-label='visualisation' data={visualisation_svg} type="image/svg+xml" onLoad={this.onSvgLoad}></object>
		);
	}

	setBurstsPerCycle(value) {
		this.BurstsPerCycle = value;
		this.__set("textBurstsPerCycle", Number(value).toFixed(0));
		this.validate();
	}
	
	setBurstsPerSecond(value) {
		this.BurstsPerSecond = value;
		this.__set("textBurstsPerSecond", Number(value).toFixed(0) + "Hz");
		this.validate();
	}
	
	setCycleTime(value) {
		//console.log(`IndividualTreatmentVisualisationBurst.setCycleTime value=${value}`);
		this.CycleTime = value;
		this.__set("textCycleTime", "" + Number(value).toFixed(1) + "s");
		this.validate();
	}
	
	setPulsesPerBurst(value) {
		this.PulsesPerBurst = value;
		this.__setBurstsPer(this.PulsesPerBurst, this.PulsesPerSecond);
	}
	
	setPulsesPerSecond(value) {
		this.PulsesPerSecond = value;
		this.__setBurstsPer(this.PulsesPerBurst, this.PulsesPerSecond);
	}
	
	__setBurstsPer(PulsesPerBurst, PulsesPerSecond) {
		this.__set("textPulsesPer", "" + PulsesPerBurst + " @ " + PulsesPerSecond + "Hz");
		this.validate();
	}
	
	validate() {
		var burstLength_s = this.PulsesPerBurst / this.PulsesPerSecond;
		var calculatedCycleTime = burstLength_s * this.BurstsPerCycle;
	
		var maximumBurstsPerSecond = 1.0 / burstLength_s;
	
		//console.log("BurstsPerCycle=" + BurstsPerCycle + " PulsesPerBurst=" + PulsesPerBurst + " @ PulsesPerSecond=" + PulsesPerSecond + "Hz takes " + burstLength_s + " seconds for each burst. maximumBurstsPerSecond=" + maximumBurstsPerSecond);
	
		if ((undefined !== this.svgTreatment) && (null !== this.svgTreatment)) {
			var textBurstsPerSecond = this.svgTreatment.getElementById("textBurstsPerSecond");
			if (this.BurstsPerSecond > maximumBurstsPerSecond) {
				console.log('Invalid BurstsPerSecond (' + this.BurstsPerSecond + 'Hz) maximum BurstsPerSecond (' + maximumBurstsPerSecond + 'Hz)');
				textBurstsPerSecond.setAttribute("fill", "red");
			}
			else {
				textBurstsPerSecond.setAttribute("fill", "rgb(255,255,255)");
			}
	

			var textCycleTime = this.svgTreatment.getElementById("textCycleTime");
			if (this.CycleTime < calculatedCycleTime) {
				console.log('Invalid CycleTime (' + this.CycleTime + 's) calculated CycleTime (' + calculatedCycleTime + 's)');
				textCycleTime.setAttribute("fill", "red");
			}
			else {
				textCycleTime.setAttribute("fill", "rgb(255,255,255)");
			}
		}
	}
}

IndividualTreatmentVisualisationBurst.propTypes = {
    AdjustedPowerOutput: PropTypes.number,
    PowerOutput: PropTypes.number,
    ChargeDelay: PropTypes.number,
    BurstsPerCycle: PropTypes.number,
    BurstsPerSecond: PropTypes.number,
    PulsesPerBurst: PropTypes.number,
    PulsesPerSecond: PropTypes.number,
    CycleTime: PropTypes.number
};

IndividualTreatmentVisualisationBurst.defaultProps = {
    AdjustedPowerOutput: 120,
    PowerOutput: 84,
    ChargeDelay: ControlConstants.UI_BURST_CHARGE_DELAY.default, // 803,
    BurstsPerCycle: ControlConstants.UI_BURST_PER_CYCLE.default, // 52,
    BurstsPerSecond: ControlConstants.UI_BURSTS_PER_SEC.default, // 5,
    PulsesPerBurst: ControlConstants.UI_PULSES_PER_BURST.default, // 3,
    PulsesPerSecond: ControlConstants.UI_BURST_PULSES_PER_SEC.default, // 50,
    CycleTime: ControlConstants.UI_BURST_CYCLE_TIME.default // 11.4
};

export default IndividualTreatmentVisualisationBurst;